module.exports = __webpack_public_path__ + "static/media/zr_2_6.636e906a.png";